import React, { Component, PropTypes } from 'react'
import './style.scss'
import Tabs from '../../components/Tabs'
import { colours, initalItemData, debounceTime, base } from '../../../config'
import { emptyArrCleaner, nextLetter, objCleaner, getTabTotals } from '../../helpers'
import Extras from '../../components/Extras'
import Actions from '../../components/Actions'
import InvoiceSheet from '../../components/InvoiceSheet'
import GraphView from '../../components/GraphView'
import JobNew from '../../components/JobNew'
import JobPlanner from '../../components/JobPlanner'
import Form from "react-jsonschema-form"
import {re_order, getTotals} from '../../helpers'
const alphabet = 'abcdefghijklmnopqrstuvwxyz'.split('')
import {debounce} from 'throttle-debounce'
import * as _ from 'lodash'
import { setJob} from '../../../core/finance'
import MediaQuery from 'react-responsive'

import ChartBar from '../../components/ChartBar'
import ChartPie from '../../components/ChartPie'
import ChartLine from '../../components/ChartLine'

export class Job extends Component {

    constructor(props) {
        super(props);
        this.state = {
          // loading: true,
          // mainJob: null,
          // menuOpen: true,
          // job: {
          //   tabs: []
          // },
          // tab: 0,
          // view: 'tabs-view',
          // delete: false
        }
        // this._tab = this._tab.bind(this)
        // this._save = this._save.bind(this)
        // this._newTab = this._newTab.bind(this)
        // this._view = this._view.bind(this)
    }

    componentDidUpdate (prevProps) {
      //if (!_.isEqual(this.state.job, this.props.job)) this.props.setJob(this.state.mainJob)
    }

    componentDidMount () {
console.log(this)
      //this.props.notify('account_succeeded_payment', 1000, 'success')
      // const _this = this
      // _this.ref = base.syncState(`user_details/${_this.props.uid}/jobs/${_this.props.params.sheet}`, {
      //     context: _this,
      //     state: 'mainJob',
      //     keepKeys: false,
      //     then () {
      //       //_this.props.setJob(this.state.mainJob)
      //       _this.ref = base.syncState(`user_details/${_this.props.uid}/sheets/${_this.props.params.sheet}`, {
      //           context: _this,
      //           state: 'job',
      //           keepKeys: false
      //       })
      //     }
      // })
    }

    // _save (data) {
    //   let formData = {}
    //   Object.keys(data.formData).map((item, i) => {
    //     if (data.formData[item] != undefined) {
    //       formData[item] = data.formData[item]
    //     } else {
    //       formData[item] = [initalItemData]
    //     }
    //   })
    //   const _this = this
    //   base.update(`user_details/${this.props.uid}/sheets/${this.props.params.sheet}/formData`, {
    //     data: objCleaner(formData),
    //     then () {
    //       const costSale = {
    //         cost: Number(getTotals(re_order(formData, 'b_cost'))),
    //         sale: Number(getTotals(re_order(formData, 'c_sale')))
    //       }
    //       base.update(`user_details/${_this.props.uid}/jobs/${_this.props.params.sheet}/total`, {
    //         data: costSale
    //       })
    //     }
    //   })
    // }
    //
    // _newTab () {
    //   if (this.state.job.tabs.length >= 24) return alert('Maximum number of tabs')
    //   const _this = this
    //   base.update(`user_details/${this.props.uid}/sheets/${this.props.params.sheet}/tabs`, {
    //     data: this.state.job.tabs.concat("New"),
    //     then () {_this._tab(_this.state.job.tabs.length-1)}
    //   })
    // }
    //
    // _tab (index) {this.setState({tab: index})}
    //
    // _view (index) {
    //   $(window).scrollTop(0)
    //   this.setState({view: index})
    // }
    //
    // _edit () {
    //   this.setState({
    //     edit: !this.state.edit
    //   })
    // }
    //
    // _delete () {
    //   this.setState({
    //     delete: !this.state.delete
    //   })
    // }
    //
    // _fullDelete () {
    //   const _this = this
    //   this.props.history.push('/jobs')
    //   base.remove(`user_details/${this.props.uid}/jobs/${this.props.params.sheet}`)
    //   base.remove(`user_details/${this.props.uid}/sheets/${this.props.params.sheet}`)
    // }
    //
    //
    // _duplicate (value) {
    //   const _this = this
    //   let newJob2 = this.state.mainJob
    //   newJob2.label = `${this.state.mainJob.label} Copy`
    //   const immediatelyAvailableReference = base.push(`user_details/${this.props.uid}/jobs`, {
    //     data: newJob2
    //   })
    //   const generatedKey = immediatelyAvailableReference.key
    //   base.fetch(`user_details/${this.props.uid}/sheets/${this.props.params.sheet}`, {
    //     context: this,
    //     then(data){
    //       base.post(`user_details/${this.props.uid}/sheets/${generatedKey}`, {
    //         data: data,
    //         then () {
    //           _this.props.history.push(`/job/${generatedKey}`)
    //           _this.props.notify('Job Sucessfully Duplicated', 1, 'success')
    //         }
    //       })
    //     }
    //   })
    // }

    // <GraphView
    //   title='Quote'
    //   job={this.state.job}
    //   active={this.state.tab}
    //   hideBottom
    // />


    render() {

        return (
          <div className="with-sidebar main-pt full-width-page">

            <JobPlanner
              colors={colours}
              uid={this.props.uid}
              details={this.props.details}
              jobId={this.props.params.sheet}
              notify={this.props.notify}
              details={this.props.details}
              view={this.props.params.view}

            />

          </div>
        )
    }
}

// <MediaQuery maxDeviceWidth={991}>
//   <div className="col-lg-3 col-md-4 ">
//     <Actions
//       colors={colours}
//       active={this.state.tab}
//       mainJob={this.state.mainJob}
//       job={this.state.job}
//       jobId={this.props.params.sheet}
//       jobId2={this.props.params.sheet}
//       history={this.props.history}
//       uid={this.props.uid}
//       tabName={this.state.job.tabs[this.state.tab]}
//       _view={this._view}
//       view={this.state.view}
//       mobile
//     />
//   </div>
// </MediaQuery>

export default Job



// WEBPACK FOOTER //
// ./src/views/pages/Job/index.js